// Labels the furthest deal step shown for a website lead.
export function dealStepLabel(row) {
  if (row?.stage === 'won') return 'won';
  const orders = Number(row?.orders) || 0;
  if (orders) return `${orders} ${orders === 1 ? 'order' : 'orders'}`;
  const quotes = Number(row?.quotes) || 0;
  return `${quotes} ${quotes === 1 ? 'quote' : 'quotes'}`;
}
